module.exports = __webpack_public_path__ + "img/loja.dc31d356.jpg";